var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotices = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19641"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 6401"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17.721 12.917V8.93a5.72 5.72 0 0 0-5.72-5.721h0A5.72 5.72 0 0 0 6.28 8.93v3.987a8.9 8.9 0 0 1-1.235 4.526h0a2.22 2.22 0 0 0 1.912 3.348h10.082a2.22 2.22 0 0 0 1.912-3.348h0a8.9 8.9 0 0 1-1.23-4.526",
  "data-name": "Path 16482"
}))));
export { SvgNotices as ReactComponent };
export default __webpack_public_path__ + "static/media/notices.d4820d08a44edbf8fee31c4bc66bf2d8.svg";